import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { fetchWebComp } from './fetcher';
/**
 * WebCompConsumer brukes for å konsumere en web component som finnes.
 * Fetcher nødvendige ressurser
 * Legger til <link> og <script> tags for relevant webcomponent så riktig js og css lastes, og oppretter element i dom'en.
 *
 * Tilsvarer "metode 3" for konsumering av web component som er dokumentert på confluence-siden for microfrontend:
 * https://confluence.nhn.no/display/HR2/@helsenorge+Microfrontend
 *
 * Eksempel:
 * Lager template og konsumerer komponenten med en gang. Brukes kun for enkelte tilfeller. Hvis webcomponent instansieres flere ganger bruk methode 1 eller 2
 * <template id="hn-webcomp-cms-block-promopanel-template"></template>
 * <WebCompConsumer
 *    domain={`${getAssetsUrl()}/cms-blocks`}
 *    entryName="cms-blocks"
 *    componentName="hn-webcomp-cms-block-promopanel"
 *    includeHelsenorgeCss
 *  />
 */
const WebCompConsumer = (props) => {
    const [isDefined, setIsDefined] = useState(() => customElements.get(props.componentName) !== undefined);
    useEffect(() => {
        fetchWebComp(props);
        customElements.whenDefined(props.componentName).then(() => {
            setIsDefined(true);
        });
    }, [props.componentName]);
    if (!isDefined) {
        return _jsx(_Fragment, { children: props.children });
    }
    const webCompFromMicroFrontend = React.createElement(props.componentName, props.componentProps, props.children);
    return _jsx(React.Fragment, { children: webCompFromMicroFrontend });
};
export default WebCompConsumer;
